import { useEffect, useState } from "react";
import { useLoaderData } from "react-router-dom";

import useService from "../../../../../../../hooks/useService";
import Contacts from "../../../../../contacts/Contacts";

export default function EntityContacts() {
  const { id } = useLoaderData();
  const fieldOptionRepository = useService("repositories/field-option-repository");
  const [fieldOptions, setFieldOptions] = useState([]);

  useEffect(() => {
    let mounted = true;

    const fetchFieldOptions = async () => {
      try {
        const options = await fieldOptionRepository.query({
          content_type: "contactrelation",
          flat: "true",
        });

        if (mounted) {
          setFieldOptions(options || []);
        }
      } catch (error) {
        if (mounted) {
          setFieldOptions([]);
        }
      }
    };

    fetchFieldOptions();

    return () => {
      mounted = false;
    };
  }, [fieldOptionRepository]);

  const contactsApi = {
    ownerId: id,
    repositoryKey: "repositories/entity-contact-repository",
    fieldOptions,
  };

  return (
    <div className="flex h-full w-full flex-col gap-3 overflow-y-auto rounded-[14px] bg-white p-6">
      <Contacts contactsApi={contactsApi} />
    </div>
  );
}
